var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        attrs: {
          type: "horizon",
          tabItems: _vm.tabItems,
          tabOptions: _vm.tabOptions,
          inlineLabel: true,
          dense: true,
          height: _vm.tabHeight,
        },
        on: {
          "update:tabItems": function ($event) {
            _vm.tabItems = $event
          },
          "update:tab-items": function ($event) {
            _vm.tabItems = $event
          },
          "update:tabOptions": function ($event) {
            _vm.tabOptions = $event
          },
          "update:tab-options": function ($event) {
            _vm.tabOptions = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    popupParam: _vm.popupParam,
                    sop: _vm.sop,
                    rev: _vm.rev,
                    isOld: _vm.isOld,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    "update:popupParam": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:popup-param": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:sop": function ($event) {
                      _vm.sop = $event
                    },
                    "update:rev": function ($event) {
                      _vm.rev = $event
                    },
                    "update:isOld": function ($event) {
                      _vm.isOld = $event
                    },
                    "update:is-old": function ($event) {
                      _vm.isOld = $event
                    },
                    getDetail: _vm.getDetail,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }